
import { granjaApi } from "../../api";
import { useMovimientosStore } from "../../store";
import Swal from "sweetalert2";







export const remesasXBodegaYProducto = async(id) => {
    try {
        const params = new URLSearchParams();
        params.append('id',  id);

        const { data } = await granjaApi.get(`/remesa/xbodega/producto`, { params });
        // useMovimientosStore.setState({ totalMovimientos: data.total });
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}  


